<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <div>
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("CRUD.info", [$t("Wave.actions.stockPiking")]) }}
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    small
                    dark
                    color="accent"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                      promptDialog = true;
                      alertMessage = $t('Wave.Messages.recommended_confirm');
                    "
                    >{{ $t("Wave.actions.toRecommended") }}</v-btn
                  >
                  <v-btn
                    v-if="
                      $permission.permissionAllow('Waves', 'saveStoragePick')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="saveRecommendPosition()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{ $t("Wave.actions.recommendedSave") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      $permission.permissionAllow('Waves', 'submitWavePicking')
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="submitWavePicking()"
                  >
                    <v-icon x-small class="pe-1">fa-check</v-icon>
                    {{ $t("Wave.actions.pickingFinish") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Wave.PickingFields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_name }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Wave.Fields.wave_code") }}{{ $t("Global.colon") }}
                    </span>
                    <span> {{ wave_code }} </span>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("Wave.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ wave_created | formatTime }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-data-table
          id="wave_details_table"
          :headers="detailsHeaders"
          :items="wavePicking"
          multi-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("Wave.PickingFields.unpick") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    wavePicked
                      ? [1, wavePicking.length, wavePicking.length]
                      : [0, 0, 0]
                  )
                }}
              </span>
            </v-toolbar>
          </template>
          <template v-slot:item.material_name="{ item }">
            <span :class="item.is_error_postion ? 'danger--text' : ''">
              <span>
                {{
                  $t(settings
                      ? settings.material_name_display_type == 1
                          ? "Material.materialName"
                          : settings.material_name_display_type == 4
                              ? "Material.nameWithCode"
                          : "Material.materialNameWithCode"
                      : "Material.materialName", [item.material_code, item.material_name])
                }}
                </span>
                <br />
              <span class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
            </span>
          </template>
          <template v-slot:item.rate_picked_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_picked_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.picked_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.default_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.rate_pick_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_pick_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.pick_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.default_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.rate_current_count="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_current_count }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_current_count | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.get_stock_position="{ item }">
            <v-btn
              text
              small
              color="action"
              @click.stop="
                recommendedPositionsDialog = true;
                currentItem = item;
                positions = item.positions;
              "
            >
              {{ $t("Wave.PickingFields.get_stock_position") }}
            </v-btn>
          </template>
          <template v-slot:item.positions="{ item }">
            <v-item-group>
              <v-item
                v-for="position in item.positions"
                :key="position.position_code"
              >
                <span v-if="item.is_error_postion" class="danger--text">
                  {{ position.Description + $t("Global.colon") }}
                  {{ position.positionNumTotal | formatTwoDot }}
                  {{ $t("Global.semicolon") }}
                </span>
                <span v-else>
                  {{ position.Description + $t("Global.colon") }}
                  {{ position.positionNumTotal | formatTwoDot }}
                  {{ $t("Global.semicolon") }}
                </span>
              </v-item>
            </v-item-group>
          </template>
        </v-data-table>

        <v-data-table
          id="already_picked_detail"
          :headers="detailsHeaders"
          :items="wavePicked"
          multi-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("Wave.PickingFields.picked") }}
              </v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    wavePicked
                      ? [1, wavePicked.length, wavePicked.length]
                      : [0, 0, 0]
                  )
                }}
              </span>
            </v-toolbar>
          </template>
          <template v-slot:item.material_name="{ item }">
            <span :class="item.is_error_postion ? 'danger--text' : ''">
              <span>
                {{
                  $t(settings
                      ? settings.material_name_display_type == 1
                          ? "Material.materialName"
                          : settings.material_name_display_type == 4
                              ? "Material.nameWithCode"
                          : "Material.materialNameWithCode"
                      : "Material.materialName", [item.material_code, item.material_name])
                }}
                </span>
                <br />
                <span class="caption secondary--text">
                  {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                  <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                    {{ item.standard_name.slice(0, 12) + "......" }}
                  </span>
                  <span v-else>
                    {{ item.standard_name }}
                  </span>
                </span>
            </span>
          </template>
          <template v-slot:item.rate_picked_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_picked_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.picked_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.default_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.rate_pick_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_pick_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.pick_num | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.default_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.rate_current_count="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.rate_current_count }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_current_count | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.get_stock_position="{ item }">
            <v-btn
              text
              small
              color="action"
              @click.stop="
                recommendedPositionsDialog = true;
                currentItem = item;
              "
            >
              {{ $t("Wave.PickingFields.get_stock_position") }}
            </v-btn>
          </template>
          <template v-slot:item.positions="{ item }">
            <v-item-group>
              <v-item
                v-for="position in item.positions"
                :key="position.position_code"
              >
                <span v-if="item.is_error_postion" class="danger--text">
                  {{ position.Description + $t("Global.colon") }}
                  {{ position.positionNumTotal | formatTwoDot }}
                  {{ $t("Global.semicolon") }}
                </span>
                <span v-else>
                  {{ position.Description + $t("Global.colon") }}
                  {{ position.positionNumTotal | formatTwoDot }}
                  {{ $t("Global.semicolon") }}
                </span>
              </v-item>
            </v-item-group>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <RecommendedPositionsDialog
      v-model="recommendedPositionsDialog"
      :material="currentItem"
      :positions="positions"
      :stock="stock"
      @positionPickNumEdit="position_pick_num_edit = $event"
    />
    <DialogAlert
      v-model="promptDialog"
      :message="alertMessage"
      persistent
      useConfirm
      @confirm="getWaveFromAPI(1)"
    />
    <DialogAlert
      v-model="isLeaveDialog"
      :message="alertMessage"
      persistent
      useConfirm
      @confirm="confirmLeave = true"
    />

    <v-dialog v-model="expiredBatchDialog" max-width="340px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="expiredBatchDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-list dense>
            <v-subheader>{{
              $t("Wave.Messages.expired_batch_error")
            }}</v-subheader>
            <v-list-item-group color="primary">
              <v-list-item v-for="(expired, i) in expiredBatch" :key="i">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ ++i + "、"
                    }}{{ expired.material_name }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="expiredBatchDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import RecommendedPositionsDialog from "./plugins/RecommendedPositionsDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import Waves from "@/api/waves";
import Stocks from "@/api/stocks";

export default {
  components: {
    Breadcrumbs,
    RecommendedPositionsDialog,
    DialogAlert,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          replace: true,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.waves"),
          disabled: false,
          href: "/waves",
        },
        {
          text: i18n.t("Nav.stockPicking"),
          disabled: true,
        },
      ];
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Wave.PickingFields.material"),
          align: "left",
          value: "material_name",
        },
        {
          text: i18n.t("Wave.PickingFields.picked_num"),
          align: "end",
          value: "rate_picked_num",
        },
        {
          text: i18n.t("Wave.PickingFields.curren_count"),
          align: "end",
          value: "rate_pick_num",
        },
        {
          text: i18n.t("Wave.PickingFields.current_stock_quantity"),
          align: "end",
          value: "rate_current_count",
        },
        {
          text: i18n.t("Wave.PickingFields.get_stock_position"),
          sortable: false,
          align: "center",
          value: "get_stock_position",
        },
        {
          text: i18n.t("Wave.PickingFields.stock_position"),
          sortable: false,
          align: "center",
          value: "positions",
        },
      ];

      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    panels: [0],
    wave_code: "",
    stock_name: "",
    stock: {},
    wave_created: "",
    wavePicking: [],
    wavePicked: [],
    expiredBatch: [],
    recommendedPositionsDialog: false,
    currentItem: null,
    positions: null,
    expiredBatchDialog: false,
    alertMessage: "",
    promptDialog: false,
    isLeaveDialog: false,
    confirmLeave: false,
    submitLeave: false,
    toPage: "",
    position_pick_num_edit: [],
  }),

  mounted() {
    //获取仓库信息
    Stocks.fetchOne(this.$route.query.stock_id).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.stock = response.data.stock;
        }
        this.getWaveFromAPI();
      }.bind(this)
    );
  },

  methods: {
    getWaveFromAPI(pick_regain) {
      //获取单据详情
      Waves.getPickingList({
        wave_id: this.$route.params.id,
        stock_id: this.$route.query.stock_id,
        pick_regain: pick_regain ? pick_regain : 0,
      }).then(
        function (response) {
          if (!response.data.status.isOK()) {
            this.expiredBatchDialog = true;
          }
          this.wave_code = response.data.wave_code;
          this.stock_name = response.data.stock_name;
          this.wave_created = response.data.time;
          //未拣
          if (
            response.data.wait_pick_detail &&
            Object.keys(response.data.wait_pick_detail).length
          ) {
            for (var pick_key in response.data.wait_pick_detail) {
              let positions = Object.values(
                response.data.wait_pick_detail[pick_key].positions
              );

              positions = positions.map((position) => {
                var Description = i18n.t(
                  "MovePositionOrder.DetailFields.position",
                  [position.position_code, position.position_name]
                );
                if (this.stock && this.stock.position_name_display) {
                  if (this.stock.position_name_display.indexOf(2) > -1) {
                    Description = position.position_name;
                  }
                  if (
                    this.stock.position_name_display.indexOf(4) > -1 &&
                    position.roadway_code
                  ) {
                    Description = position.roadway_code + " - " + Description;
                  }
                  if (
                    this.stock.position_name_display.indexOf(3) > -1 &&
                    position.area_name
                  ) {
                    Description = position.area_name + " - " + Description;
                  }
                }

                return Object.assign({}, position, { Description });
              });

              response.data.wait_pick_detail[pick_key].positions = positions;
            }
            this.wavePicking = Object.values(response.data.wait_pick_detail);
          }
          //已拣
          if (
            response.data.already_picked_detail &&
            Object.keys(response.data.already_picked_detail).length
          ) {
            for (var picked_key in response.data.already_picked_detail) {
              let positions = Object.values(
                response.data.already_picked_detail[picked_key].positions
              );

              positions = positions.map((position) => {
                var Description = i18n.t(
                  "MovePositionOrder.DetailFields.position",
                  [position.position_code, position.position_name]
                );
                if (this.stock && this.stock.position_name_display) {
                  if (this.stock.position_name_display.indexOf(2) > -1) {
                    Description = position.position_name;
                  }
                  if (
                    this.stock.position_name_display.indexOf(4) > -1 &&
                    position.roadway_code
                  ) {
                    Description = position.roadway_code + " - " + Description;
                  }
                  if (
                    this.stock.position_name_display.indexOf(3) > -1 &&
                    position.area_name
                  ) {
                    Description = position.area_name + " - " + Description;
                  }
                }

                return Object.assign({}, position, { Description });
              });

              response.data.already_picked_detail[picked_key].positions =
                positions;
            }
            this.wavePicked = Object.values(
              response.data.already_picked_detail
            );
          }
          //过期库位批次
          if (response.data.error_position) {
            this.expiredBatch = Object.values(response.data.error_position);
          }
        }.bind(this)
      );
    },

    saveRecommendPosition() {
      var pick_details = [];
      this.wavePicking.forEach(function (wave_picking_detail) {
        wave_picking_detail.positions.forEach(function (position) {
          var pick_detail = {
            material_id: position.material_id,
            default_num: position.default_unit_num
              ? position.default_unit_num
              : Number(position.positionNumTotal),
            stock_num: position.stock_unit_num ? position.stock_unit_num : 0,
            position_id: position.stock_position_id,
          };
          pick_details.push(pick_detail);
        });
      });

      Waves.saveStoragePick({
        wave_id: this.$route.params.id,
        pick_details: pick_details,
      }).then(
        function (response) {
          if (response.data.status.isOK) this.submitLeave = true; //跳过离开此页面弹窗拦截
        }.bind(this)
      );
    },

    submitWavePicking() {
      var pick_details = [];
      this.wavePicking.forEach(
        function (wave_picking_detail) {
          wave_picking_detail.positions.forEach(
            function (position) {
              var pick_detail = {
                material_id: position.material_id,
                stock_num: position.stock_unit_num
                  ? position.stock_unit_num
                  : 0,
                default_num: position.default_unit_num
                  ? position.default_unit_num
                  : Number(position.positionNumTotal),
                position_id: position.stock_position_id,
              };
              pick_details.push(pick_detail);
            }.bind(this)
          );
        }.bind(this)
      );

      Waves.submitWavePicking({
        completePick: 1,
        wave_id: this.$route.params.id,
        stock_id: this.$route.query.stock_id,
        pick_details: pick_details,
      }).then(
        function (response) {
          if (response.data.status.isOK) this.submitLeave = true; //跳过离开此页面弹窗拦截
        }.bind(this)
      );
    },
  },

  watch: {
    position_pick_num_edit: {
      immediate: true,
      handler() {
        this.position_pick_num_edit.forEach(
          function (pick_num_edit) {
            var materialPicking = this.wavePicking.find(
              (detail) => detail.material_id == pick_num_edit.material_id
            );

            var positionPickNumTotal = 0;
            if (pick_num_edit.rate > 1) {
              if (pick_num_edit.stock_num) {
                //大单位化小单位
                positionPickNumTotal +=
                  pick_num_edit.stock_num * pick_num_edit.rate;
              }
            }
            if (Number(pick_num_edit.default_num)) {
              positionPickNumTotal += pick_num_edit.default_num;
            }
            //拣货库位
            var materialPosition = Object.values(
              materialPicking.positions
            ).find((material_position) =>
              material_position.stock_position_id ==
              pick_num_edit.stock_position_id
                ? material_position
                : ""
            );
            if (positionPickNumTotal) {
              //新增在其他库位设置拣货量
              if (!materialPosition) {
                materialPicking.positions.push({
                  material_id: materialPicking.material_id,
                  positionNumTotal: positionPickNumTotal,
                  stock_position_id: pick_num_edit.stock_position_id,
                  position_name: pick_num_edit.position_name,
                  default_unit_num: pick_num_edit.default_num,
                  stock_unit_num: pick_num_edit.stock_num
                    ? pick_num_edit.stock_num
                    : 0,
                });
              } else {
                materialPosition.positionNumTotal = positionPickNumTotal;
                materialPosition.default_unit_num = pick_num_edit.default_num;
                materialPosition.stock_unit_num = pick_num_edit.stock_num
                  ? pick_num_edit.stock_num
                  : 0;
              }
            } else {
              materialPicking.positions.forEach(function (item, i) {
                if (
                  item.stock_position_id == materialPosition.stock_position_id
                ) {
                  materialPicking.positions.splice(i, 1);
                }
              });
            }
          }.bind(this)
        );
      },
    },
    confirmLeave: {
      handler() {
        this.$router.replace(this.toPage.path);
      },
    },
    submitLeave: {
      handler() {
        if (this.submitLeave) this.$router.replace("/waves");
      },
    },
  },

  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (!this.submitLeave) {
      // console.log(this.submitLeave)
      this.isLeaveDialog = true;
      this.alertMessage = i18n.t("Wave.Messages.leave_confirm");
      this.toPage = to;
      if (this.confirmLeave) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>